import axios, { type AxiosError } from 'axios';

import type * as ordersBatchActions from '~/actions/orders-batch.actions';

import {
  MONTHLY_LABEL_LIMIT_EXCEEDED,
  UNABLE_TO_PROCESS_REQUEST,
  VERIFICATION_REQUIRED_ERROR,
} from '~/constants/errors/apiMessageErrorCodes';
import { APIErrorCategory } from '~/utils/APIErrorClassification/APIErrorClassification';
import { observability } from '~/utils/observability';

export const batchTransactionsErrorHandler = (
  action: ReturnType<typeof ordersBatchActions.createBatchTransactions>,
  err: AxiosError,
  callback?: (() => void) | undefined,
) => {
  if (axios.isAxiosError(err) && err.response && err.response.config?.url) {
    if (err.response.config.url.match(/\/batch\/\d+\/transactions/)) {
      const { code, detail, remaining_labels_until_limit, requires_verification } =
        err.response.data;
      let message = detail;
      if (requires_verification) message = VERIFICATION_REQUIRED_ERROR;
      if (remaining_labels_until_limit < action.payload.batchEntryIds.length)
        message = MONTHLY_LABEL_LIMIT_EXCEEDED;
      if (!message) message = UNABLE_TO_PROCESS_REQUEST;
      action.payload.batchEntryIds.forEach((batchEntryId) => {
        observability.errorEvent('LABEL_PURCHASED', {
          batchEntryId,
          errorCategory: APIErrorCategory.BATCH_TRANSACTION_API,
          errorCodes: code || 'Unknown',
          errorCount: 1,
          errorMessages: message,
          errorSources: 'Shippo',
          id: `${batchEntryId}`,
        });
      });

      if (typeof callback === 'function') callback();
    }
  }
};
